import { firebase } from "./firebase"
import { elasticsearch } from "./elasticsearch"
import {postSearch} from "./postSearch";

export const config = {
	firebase: firebase,
	elasticsearch: elasticsearch,
	postSearch: postSearch
};


// WEBPACK FOOTER //
// ./src/config/index.js